import React from "react";
import styles from "./ReviewLink.module.css";

type Props = {
    label: string;
    href: string;
    className?: string;
};

export default function ReviewLink(props: Props) {
    return (
        <div className={props.className}>
            <a
                className={styles.container}
                href={props.href}
                target="_blank"
                rel="noopener noreferrer"
            >
                {props.label}
            </a>
        </div>
    );
}
